import { useTheme } from 'styled-components';

import { Tooltip } from '../../../components/Tooltip';
import { Icon } from '../../../ui';
import { ToolBarProps } from '../ToolBar.types';
import { NavigationItemProps } from './Navigation';
import { Divider, NavItem, NavItemLabel, StyledNavItemContainer } from './Navigation.style';
import { NavItemProps } from './Navigation.types';

export type NavigationButtonProps = {
  item: NavItemProps;
  variant: ToolBarProps['variant'];
  activeItem: string | null;
  isFeatured?: boolean;
  onClick?: (item: NavigationItemProps) => void;
};
export const NavigationButton = function ({
  item,
  variant,
  activeItem,
  onClick,
  isFeatured,
}: NavigationButtonProps) {
  const theme = useTheme();

  return (
    <Tooltip text={item?.label} visible={variant === 'float'} position="right">
      <StyledNavItemContainer data-menu={item.type}>
        <NavItem
          isFeatured={isFeatured}
          variant={variant}
          active={item.type === activeItem}
          onClick={() => {
            const preventExecution = item.onClick?.(item) === false;

            if (preventExecution) return;

            onClick?.(item);
          }}
        >
          {item.type === 'divider' ? (
            <Divider />
          ) : (
            item.icon && (
              <>
                <Icon
                  name={item.icon}
                  size={'Medium'}
                  title={item.label}
                  color={isFeatured ? theme.Color.Brand.Primary : theme.Color.Neutrals.Dark}
                  highlightColor={theme.Color.Brand.Primary}
                />
                {variant === 'static' && item.label && <NavItemLabel>{item.label}</NavItemLabel>}
              </>
            )
          )}
        </NavItem>
      </StyledNavItemContainer>
    </Tooltip>
  );
};
